import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";
import { useDataGridSettings } from "../DataGridSettingsProvider";

export default function IncludeDismissedEventsMenuItem() {
  const { includeDismissedWarnings, setIncludeDismissedWarnings } = useDataGridSettings();
  const { t } = useTranslation();
  return (
    <MenuItem onClick={() => setIncludeDismissedWarnings(!includeDismissedWarnings)}>
      <ListItemText>{t("faultOverview.includeDismissedEvents")}</ListItemText>
      <Checkbox checked={includeDismissedWarnings} />
    </MenuItem>
  );
}
